import { getHybridApp } from '@vmos2/core';

// Function to open a new browser window.
// On mobile native apps it will use the InAppBrowser cordova plugin instead of window object.
export const openWindowBrowser = async (url: string, windowOptions: string, target = '_blank') => {
  const hybridApp = await getHybridApp();
  let options: string | undefined;

  if (hybridApp && hybridApp.InAppBrowser) {
    if (windowOptions) {
      // `noopener` and `noreferrer` are not supported by the inAppBrowser.
      options = windowOptions.replace(/noopener|noreferrer/g, '');
    }

    hybridApp.InAppBrowser.open(url, target, options);
  } else {
    window.open(url, target, windowOptions);
  }
};
